import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import CloudMigrationPage from './pages/services/CloudMigrationPage';
import CloudSecurityPage from './pages/services/CloudSecurityPage';
import DataAIPage from './pages/services/DataAIPage';
import CostOptimizationPage from './pages/services/CostOptimizationPage';
import ManagedServicesPage from './pages/services/ManagedServicesPage';
import DevOpsPage from './pages/services/DevOpsPage';
import EcommercePage from './pages/solutions/EcommercePage';
import FinTechPage from './pages/solutions/FinTechPage';
import AIMLPage from './pages/solutions/AIMLPage';
import ManufacturingPage from './pages/solutions/ManufacturingPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          
          {/* Services Routes */}
          <Route path="/services/cloud-migration" element={<CloudMigrationPage />} />
          <Route path="/services/cloud-security" element={<CloudSecurityPage />} />
          <Route path="/services/data-ai-ml" element={<DataAIPage />} />
          <Route path="/services/cost-optimization" element={<CostOptimizationPage />} />
          <Route path="/services/managed-services" element={<ManagedServicesPage />} />
          <Route path="/services/devops" element={<DevOpsPage />} />
          
          {/* Solutions Routes */}
          <Route path="/solutions/ecommerce" element={<EcommercePage />} />
          <Route path="/solutions/fintech" element={<FinTechPage />} />
          <Route path="/solutions/ai-ml" element={<AIMLPage />} />
          <Route path="/solutions/manufacturing" element={<ManufacturingPage />} />
          
          {/* Other Routes */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;